import { Box, Button, TextInput } from "grommet"

export const TextInputWithButton = ({ name, type = "text", placeholder, value, readOnly = false, onChange, children, ...props }) => {

    return (
        <Box direction="row" border round="xsmall" {...props}>
            <TextInput name={name} type={type} placeholder={placeholder} plain value={value} readOnly={readOnly} onChange={onChange} focusIndicator={false} />
            {children}
            {/* <Button style={{ borderTopRightRadius: '6px', borderBottomRightRadius: '6px', borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }} icon={icon} onClick={onClick} /> */}
        </Box>
    )
}